import { useState } from 'react';
import Editor, {
  BtnBold,
  BtnBulletList, BtnClearFormatting,
  BtnItalic, BtnLink,
  BtnNumberedList, BtnStrikeThrough,
  BtnStyles, BtnUnderline,
  EditorProps, Separator,
  Toolbar
} from 'react-simple-wysiwyg';

export const RichTextEditor = (props: EditorProps): JSX.Element => {

  const [html, setHtml] = useState(props.value);

  function onChange(e) {
    setHtml(e.target.value);
    props.onChange && props.onChange(e);
  }

  return (
    <Editor value={html} onChange={onChange}>
      <Toolbar>
        <BtnStyles />
        <BtnBold />
        <BtnItalic />
        <BtnUnderline />
        <BtnStrikeThrough />
        <BtnBulletList />
        <BtnNumberedList />
        <BtnLink />
        <BtnClearFormatting />
        <Separator />
      </Toolbar>
    </Editor>
  );
};
